import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import { useState } from 'react';

import {
  BuildYourTeamStartBody,
  BuildYourTeamStartFooter,
} from './build-your-team';
import { BuildYourTeam1Body, BuildYourTeam1Footer } from './build-your-team-1';
import { BuildYourTeam2Body, BuildYourTeam2Footer } from './build-your-team-2';

const BuildYourTeam = ({ modal }: { modal: any }) => {
  const [tutorialModalContent, setTutorialModalContent] = useState(
    'buildYourTeamStart'
  );

  return (
    <>
      <Modal
        isOpen={modal.isOpen}
        onClose={() => {
          modal.onClose();
          modal.openChecklistModal();
          setTutorialModalContent('buildYourTeamStart');
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent maxW="800px">
          <ModalCloseButton color="gray.500" />
          <ModalBody px="60px" pt="40px" pb="24px" bg="white">
            {tutorialModalContent === 'buildYourTeamStart' && (
              <BuildYourTeamStartBody />
            )}
            {tutorialModalContent === 'buildYourTeam1' && (
              <BuildYourTeam1Body />
            )}
            {tutorialModalContent === 'buildYourTeam2' && (
              <BuildYourTeam2Body />
            )}
          </ModalBody>
          <ModalFooter
            flexDirection="column"
            alignItems="center"
            bg="gray.100"
            px="60px"
            py="25px"
          >
            {tutorialModalContent === 'buildYourTeamStart' && (
              <BuildYourTeamStartFooter
                setNextModal={setTutorialModalContent}
              />
            )}
            {tutorialModalContent === 'buildYourTeam1' && (
              <BuildYourTeam1Footer setNextModal={setTutorialModalContent} />
            )}
            {tutorialModalContent === 'buildYourTeam2' && (
              <BuildYourTeam2Footer
                completed={modal.completed}
                closeModal={() => {
                  modal.onClose();
                  modal.openChecklistModal();
                  setTutorialModalContent('buildYourTeamStart');
                }}
              />
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default BuildYourTeam;
